<script>
export default {
  functional: true,

  props: {
    chevron: { type: Boolean, default: false },
    noPaddingTop: { type: Boolean, default: false },
    alignStart: { type: Boolean, default: false }
  },

  render(h, { props, slots, listeners, data }) {
    let classList = ["v-list-item", data.class, data.staticClass]
    let attrs = data.attrs || {}

    if (props.chevron) classList.push("--chevron")

    return (
      <div class={classList.join(" ")} on={listeners} {...{ attrs }}>
        <div
          class={[
            props.noPaddingTop ? "pt-0" : "",
            props.alignStart ? "align-items-start" : "",
            "v-list-item__row"
          ]}
        >
          {slots().left && <div class="v-list-item__left">{slots().left}</div>}
          <div class="v-list-item__center">{slots().default}</div>
          {slots().right && (
            <div class="v-list-item__right">{slots().right}</div>
          )}
        </div>
        {slots().row && <div class="v-list-item__row">{slots().row}</div>}
      </div>
    )
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.v-list-item {
  position: relative;
  border-bottom: 1px solid $color-ui--grey-15;
  padding: 0 0 1rem 0;
  cursor: pointer;

  &:hover {
    background: $color-ui--grey-10;
  }

  &:last-child {
    border-bottom: none;
  }

  .v-list-item__row {
    display: flex;
    padding: $size--4;
    padding-bottom: 0;

    &:nth-of-type(2) {
      padding-top: 1rem;
    }
  }

  .v-list-item__center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
  }

  .v-list-item__right {
    margin-left: auto;
    align-self: center;
  }

  .v-list-item__title {
    font-weight: $font-weight--semi-bold;
    align-self: flex-start;
    flex-basis: auto;
    line-height: $size--5;
    display: block;
    width: 100%;

    &.--centered {
      align-self: center;
    }
  }

  .v-list-item__subtitle {
    opacity: 0.75;
    font-size: $font-size--small;
    line-height: $size--5;
  }

  .v-list-item__icon,
  .v-icon {
    font-size: $size--6;
    color: $color-ui--grey-70;
    width: $size--6;
    text-align: center;
    position: relative;
    top: 2px;
    margin-right: $size--1;
  }

  &.--chevron {
    .v-list-item__row {
      padding-right: 3rem;
    }

    &:before {
      content: "";
      position: absolute;
      border-right: 2px solid #c7c7cc;
      border-bottom: 2px solid #c7c7cc;
      width: 7px;
      height: 7px;
      background-color: transparent;
      z-index: 5;
      top: 50%;
      right: $size--6;
      transform: translateY(-50%) rotate(-45deg);
    }
  }
}
</style>
